/* 본인 정보 미리 고르기(9/28) — 사장님 「… 그 계정으로 다시 사주나 타로를 볼 때 생년월일이나 태어난시가 기존에 골랐던 걸로 선택이 되있게끔」
   → 「궁합은 본인만 저장하고 상대방은 저장하지마 그리고 서버 저장으로 가고 지침 변경해」.
   무비(play.js)가 입력을 받기 전에 load() 로 계정에 저장된 본인 생년월일 · 태어난 시각 · 성별을 받아 바퀴 · 고르기의 기본값으로 쓰고,
   입력이 끝나면 save() 로 본인 칸 셋만 계정에 남긴다(deploy/me.js). 상대(그 사람 · 첫 번째 · 두 번째 사람) · 헤어진 날은 넘기지 않는다.
   로그인하지 않았으면 서버가 남기지 않는다. 로그인한 뒤 again() 을 부르면 그때 남긴다.
   토스판은 토스 익명 키로 남긴다(tosspay.js 의 window.BGTOSS.head — 부를 때 읽는다. tosspay.js 는 이 파일보다 뒤에 실린다). */
(() => {
  // 10/1 코드 점검 — 이 탭의 보기 번호(x-bg-session)도 싣는다. 서버 보관함은 이제 산 풀이만 받는데(deploy/me.js), 같은 탭에서 비회원으로 산 것도 이 번호로 알아본다
  const sid = () => { try { const v = sessionStorage.getItem("bg.pay.sid") || ""; return /^[A-Za-z0-9_-]{16,64}$/.test(v) ? { "x-bg-session": v } : {}; } catch { return {}; } };
  const head = () => ({ "Content-Type": "application/json", ...(window.BGTOSS ? window.BGTOSS.head() : {}), ...sid() });
  // opt.keepalive — 화면을 닫는 중에도 끝까지 보낸다(무비 flushVault, 10/1 코드 점검). 브라우저는 몸 64KB 까지만 받아 주므로 넘으면 보통으로 보낸다
  const post = (path, body, opt) => {
    const b = JSON.stringify(body || {}), keep = !!opt?.keepalive && new TextEncoder().encode(b).length < 60000;
    return fetch(`/api/me/${path}`, { method: "POST", headers: head(), body: b, ...(keep ? { keepalive: true } : {}) })
      .then(async (r) => { const j = await r.json().catch(() => ({})); if (!r.ok) throw Object.assign(new Error(j.error || "실패"), { status: r.status }); return j; });
  };
  let got = null, want = null, sent = "";
  // 저장된 값 — { birthDate: "YYYY-MM-DD", birthTime: "HH:MM" | null, sex: "male" | "female" } 또는 null. 한 번만 묻는다
  const load = () => (got ??= post("birth").then((j) => j?.본인 || null).catch(() => null));
  function save(p) {
    want = p;
    const k = JSON.stringify(p);
    if (!p || k === sent) return;
    post("birth/save", p).then(() => { sent = k; }).catch(() => { /* 로그인 전 · 서버 준비 전 — 로그인하면 again() 이 다시 */ });
  }
  const again = () => { if (want) save(want); };
  /* 10/1 코드 점검 — 이 기기 보관함 풀이의 주인 표(src/auth.js ownerOf 와 같은 꼴). 토스판은 토스 익명 키, 웹은 「kakao:계정표」(deploy/auth.js /api/auth/me 의 key).
     무비가 로그인한 채로 남긴 풀이에 붙여, 로그인이 풀린 뒤 다른 계정이 로그인해도 그 계정 보관함으로 올라가지 않게 한다. 시험 로그인 · 비회원은 null. */
  let owner = null, ownerP = null, ownerGen = 0;
  const 계정표 = (u) => u && !u.mock && /^[0-9a-f]{24}$/.test(String(u.key || "")) ? `${u.provider}:${u.key}` : null;
  const whose = () => {
    const gen = ++ownerGen;
    owner = null;
    if (window.BGTOSSAUTH) {
      ownerP = window.BGTOSSAUTH.ready().then((u) => { if (gen !== ownerGen) return owner; owner = u.key; return owner; }).catch(() => { if (gen !== ownerGen) return owner; owner = null; return null; });
      return;
    }
    const k = window.BGTOSS ? String(window.BGTOSS.head()?.["x-toss-key"] || "") : "";
    if (/^toss:/.test(k)) { owner = k; ownerP = Promise.resolve(owner); return; }
    if (window.BGTOSS) return;
    ownerP = fetch("/api/auth/me", { cache: "no-store" }).then((r) => r.json()).then((j) => {
      if (gen !== ownerGen) return owner;
      owner = 계정표(j?.user);
      return owner;
    }).catch(() => { if (gen !== ownerGen) return owner; owner = null; return null; });
  };
  // 9/30 보관 풀이 — 확인된 계정과 이 기기 칸의 주인이 같을 때만 서버에 남긴다. 주인 없는 칸·확인 실패는 올리지 않는다.
  const vaultSave = (id, result, opt) => {
    const gen = ownerGen;
    const claim = opt?.claim || null;
    const run = (who) => {
      if (gen !== ownerGen || !who) return;
      let list = null;
      try { const raw = JSON.parse(localStorage.getItem("bambee.vault.v1") || "[]"); list = Array.isArray(raw) ? raw : []; } catch { list = null; }
      const e = list?.find((x) => x.id === id) || null;
      if (e?.owner && e.owner !== who) return;
      const 이번 = claim && claim === who;
      if (!이번 && (!e?.owner || e.owner !== who)) return;
      const mark = (서버) => {
        try {
          const now = JSON.parse(localStorage.getItem("bambee.vault.v1") || "[]"), row = Array.isArray(now) ? now.find((x) => x.id === id) : null;
          if (!row || JSON.stringify(row.result) !== JSON.stringify(result) || (row.owner && row.owner !== who)) return;
          if (서버) { row.owner = who; row.서버 = true; delete row.로컬만; } else if (row.owner === who) row.로컬만 = true;
          localStorage.setItem("bambee.vault.v1", JSON.stringify(now));
        } catch { /* 이 기기 저장이 막혀도 서버 저장은 이미 끝났다 */ }
      };
      return post("vault/save", { id, result, owner: who }, opt).then(() => mark(true)).catch((err) => { if (err.status === 403) mark(false); });
    };
    if (ownerP) return ownerP.then(run);
    return run(owner);
  };
  const when = () => ownerP || Promise.resolve(owner);
  // 10/28 이 탭 표 — 비회원으로 이 탭에서 남긴 결과 칸에 단다(무비 saveVault · 타로 saveTarot). 로그인하면 이 표가 달린 칸만 넘겨받기에 대 본다
  //   (src/vault.js adoptGuest — 같은 기기의 다른 탭 · 다른 사람이 남긴 칸은 대지 않는다). 결제 탭 번호(bg.pay.sid)는 기기에 남기지 않으려 따로 만든다
  const tab = () => {
    try { let t = sessionStorage.getItem("bg.vault.tab"); if (!t) sessionStorage.setItem("bg.vault.tab", (t = crypto.randomUUID?.() || `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`)); return t; }
    catch { return null; }
  };
  window.addEventListener("storage", (e) => { if (e.key === "bg.login") whose(); });
  // 모든 스크립트(토스판의 tosspay.js 포함)가 실린 뒤 미리 물어 둔다 — 무비의 첫 입력까지 인트로가 있어 그사이에 온다
  const boot = () => { load(); whose(); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true }); else boot();
  window.BGME = { load, save, again, vaultSave, owner: () => owner, when, gen: () => ownerGen, tab };
})();
